import streakProtection from './streakProtection';
import interfaceCopy from './interface';
import reviewLevelUp from './reviewLevelUp';
import writingExam from './writingExam';
import dashboard from './dashboard';
import accountActivity from './accountActivity';
import learningNavigation from './learningNavigation';
import authUx from './authUx';
import tournamentUx from './tournamentUx';
import theme from './theme';
import notesUnified from './notesUnified';
import quickPractice from './quickPractice';
import practiceUi from './practiceUi';
import vocabulary from './vocabulary';

const ko = {
  streakProtection: streakProtection.ko,
  vocabulary: vocabulary.ko,
  reviewLevelUp: reviewLevelUp.ko,
  writingExam: writingExam.ko,
  practiceUi: practiceUi.ko,
  notesUnified: notesUnified.ko,
  quickPractice: quickPractice.ko,
  interface: interfaceCopy.ko,
  dashboard: dashboard.ko,
  accountActivity: accountActivity.ko,
  learningNavigation: learningNavigation.ko,
  authUx: authUx.ko,
  tournamentUx: tournamentUx.ko,
  theme: theme.ko,
  app: {
    title: {
      aria: '영어 훈련소',
      language: '영어',
      pt: '훈련소',
      club: '',
      subtitle: '소리내라 그리고 반복하라',
    },
  },
  common: {
    close: '닫기',
    ok: '확인',
    cancel: '취소',
    save: '저장',
    next: '다음',
    continue: '계속',
    startTraining: '훈련 시작',
    confirmTitle: '진행할까요?',
  },
  playerLevelUp: {
    title: '레벨 업!',
    message: '이번 훈련으로 레벨 {previousLevel}에서 레벨 {level}(으)로 올랐어요.',
  },
  noteCompletion: {
    title: '노트 완료!',
    message: '“{noteTitle}”의 모든 카드를 학습 완료했어요. 멋져요!',
    untitled: '제목 없는 노트',
  },
  recordAchievement: {
    title: '기록 달성!',
    message: '{record} 기록을 달성했어요. 멋진 카드가 열렸습니다!',
  },
  pwa: {
    installButton: '앱으로 설치하기',
    installTitle: '영어훈련소 설치하기',
    iosSafariInstructions: 'Safari의 공유 버튼을 누른 뒤 홈 화면에 추가를 선택하세요. 추가하기 전에 앱 이름을 확인하거나 바꿀 수 있습니다.',
    iosBrowserInstructions: '이 페이지를 Safari에서 여세요. 공유 버튼을 누른 뒤 홈 화면에 추가를 선택하세요.',
    browserInstructions: '브라우저 메뉴를 열고 앱 설치 또는 홈 화면에 추가를 선택하세요. 브라우저에서 설치 준비가 확인되면 설치 메뉴가 나타납니다.',
  },
  auth: {
    headings: {
      login: '로그인',
      signup: '계정 만들기',
      forgot: '비밀번호 재설정',
      reset: '새 비밀번호 설정',
      verify: '이메일 확인',
    },
    labels: {
      email: '이메일',
      nickname: '닉네임',
      password: '비밀번호',
      confirmPassword: '비밀번호 확인',
    },
    buttons: {
      working: '처리 중...',
      agreeAndCreate: '동의하고 계정 만들기',
      backToForm: '돌아가기',
    },
    links: {
      signIn: '로그인',
      createAccount: '계정 만들기',
      forgotPassword: '비밀번호를 잊으셨나요?',
    },
    messages: {
      emailVerified: '이메일 확인이 완료되었습니다. 이제 로그인할 수 있어요.',
      verifyFailed: '이메일 확인에 실패했습니다.',
      accountCreated: '계정이 생성되었습니다. 이메일 확인 링크를 확인해 주세요.',
      resetSent: '가입된 이메일이라면 재설정 링크가 발송됩니다.',
      resetComplete: '비밀번호가 변경되었습니다. 이제 로그인할 수 있어요.',
      failed: '인증에 실패했습니다. 다시 시도해 주세요.',
    },
    validation: {
      passwordMin: '비밀번호는 8자 이상이어야 합니다.',
      passwordLetterNumber: '비밀번호에는 영문자와 숫자가 하나 이상 포함되어야 합니다.',
      passwordMismatch: '비밀번호가 일치하지 않습니다.',
      agreementRequired: '서비스 이용 약관에 동의해 주세요.',
    },
    agreement: {
      title: '서비스 이용 동의',
      intro: 'English PT Club 계정을 만들기 전에 아래 내용을 확인해 주세요.',
      terms: [
        '서비스 이용을 위해 이메일, 닉네임, 학습 기록 등 계정 및 학습 데이터를 저장합니다.',
        '앱은 학습 진행도, 포인트, 반복 횟수, 연습 시간 등을 기록하여 개인화된 학습 경험을 제공합니다.',
        '서비스 운영, 오류 수정, 보안 유지, 기능 개선을 위해 필요한 범위에서 데이터를 처리할 수 있습니다.',
        '비밀번호는 암호화되어 저장되며, 이메일 인증 및 비밀번호 재설정 안내를 위해 이메일이 사용될 수 있습니다.',
      ],
      improvement: '학습 데이터는 이 프로그램의 품질 개선과 기능 향상을 위해 사용될 수 있습니다.',
      checkbox: '위 내용을 확인했으며 서비스 이용 및 데이터 활용에 동의합니다.',
    },
  },
  levelUp: {
    guidance: '문장을 업그레이드하세요. 핵심 표현은 유지하되, 시제를 바꾸거나 질문문/부정문으로 만들거나, 주어나 목적어를 바꿔도 좋아요. 앞뒤 문장을 더해 짧은 대화를 완성해 보세요.',
    title: '레벨 업!',
    successMessage: '카드가 Level {level}에 도달했어요. 나만의 문장을 계속 만들어 봐요.',
  },
  autoRepeat: {
    title: '자동 반복할까요?',
    confirm: '자동 반복',
    limitMessage: '포인트 한도에 도달하기 전까지 {count}회만 반복합니다. +{score} pt.',
    fillMessage: '이 카드의 남은 반복 {count}회를 채웁니다. +{score} pt.',
    repeatSingular: '반복',
    repeatPlural: '반복',
  },
  gradeThreeMilestone: {
    title: '3등급 달성',
    message: '진도가 빠르네! {score} pt만에 3등급에 도달했어.',
    iconAlt: '3등급 달성을 축하하는 트레이너',
  },
  practicePhases: {
    memoryTrial: {
      title: '유창성 시험',
      label: '유창성 시험',
      speedLabel: '유창성 시험',
      start: '얼마나 빨리 말할 수 있는지도 중요해. 오늘은 시험 대상은 {count}개 카드야.',
      startImageAlt: '유창성 시험 시작',
      completeTitle: '유창성 시험 완료',
      completeToCore: '수고했어! {success}개 성공하고 {fail}개 실패했어.',
      completeWithoutCore: '수고했어! {success}개 성공하고 {fail}개 실패했어.',
      endImageAlt: '유창성 시험 완료',
    },
    coreTraining: {
      title: '기본 훈련',
    },
    reading: {
      title: '리딩 연습',
      start: '리딩 연습입니다. 읽고 따라하세요.',
      startImageAlt: '리딩 연습을 안내하는 Beep',
    },
    npcEncounter: {
      title: 'NPC 조우',
    },
  },
  browserTts: {
    play: '이 문장 듣기',
    stop: '문장 듣기 중지',
    membership: '멤버십 문장 듣기',
    unavailableTitle: '브라우저 음성을 사용할 수 없어요',
    unavailableMessage: '이 브라우저에서 문장을 재생할 수 없습니다. 기기의 음성 설정을 확인하거나 다른 브라우저에서 다시 시도해 주세요.',
  },
  readingSpeech: {
    frontBonus: 'Front +{score} pt',
    noFlipBonus: 'Not flipping +{score} pt',
    midSentenceBonus: 'Long +{score} pt',
    longSentenceBonus: 'Long +{score} pt',
  },
  membership: {
    labels: {
      membership: '멤버십',
      trial: '체험 멤버십',
      user: 'User',
    },
    dailyLimit: {
      title: '오늘의 운동을 모두 마쳤어요',
      message: '오늘 이용할 수 있는 운동 2회를 모두 사용하셨어요. 기억이 자리 잡을 시간을 가진 뒤 내일 다시 만나요. 멤버십에서는 하루 횟수 제한 없이 운동할 수 있습니다.',
    },
    practiceUnavailable: {
      title: '운동을 시작할 수 없어요',
      message: '지금은 운동을 열 수 없습니다. 연결 상태를 확인한 뒤 다시 시도해 주세요.',
    },
    tts: {
      title: '멤버십 듣기',
      message: 'TTS 음성 만들기와 듣기는 멤버십 기능입니다. 멤버십에서는 하루 횟수 제한 없이 운동할 수도 있어요. English PT Club과 함께 성장해 주셔서 감사합니다.',
    },
    account: {
      membership: 'English PT Club 멤버십과 함께해 주셔서 진심으로 감사합니다. 보내 주시는 응원 덕분에 더 좋은 훈련을 만들 수 있습니다. 횟수 제한 없는 운동과 TTS 듣기를 자유롭게 이용해 주세요.',
      trial: '7일 멤버십 체험이 {date}까지 열려 있어요. 모든 문이 열린 동안 횟수 제한 없는 운동과 TTS 듣기를 마음껏 경험해 보세요.',
      user: '더 깊은 훈련으로 가는 다음 문이 기다리고 있어요. 멤버십에서는 횟수 제한 없는 운동과 TTS 듣기가 열립니다. 멤버십 신청은 곧 준비될 예정입니다.',
    },
  },
  practicePlayer: {
    modes: {
      focus: '집중',
      drill: '훈련',
      review: '복습',
    },
    modeDescriptions: {
      focus: '반복 횟수가 적은 오늘의 카드를 우선합니다. 정답을 4번 재생합니다.',
      drill: '완료되지 않은 카드를 무작위로 훈련합니다. 정답을 4번 재생합니다.',
      review: '완료한 카드를 무작위로 복습합니다. 정답을 4번 재생합니다.',
    },
    settings: {
      testRepeatName: '시험, 반복 훈련',
      testRepeatDescription: '질문에 대답하고, 반복해서 읽습니다. 플래시카드 학습, 말하기 학습.',
      listeningName: '듣기 훈련',
      listeningDescription: '질문과 답을 듣고, 반복해서 따라합니다. 듣기, 쉐도잉, 말하기 학습.',
    },
    empty: {
      title: '재생할 카드가 없습니다',
      focus: '지금 집중 훈련할 준비가 된 카드가 없습니다.',
      drill: '선택한 종류에 해당하는 미완료 카드가 없습니다.',
      review: '선택한 종류에 해당하는 완료 카드가 없습니다.',
    },
    page: {
      title: '연습 플레이어',
      preparing: '재생 목록을 준비하고 있습니다...',
      ready: '재생 준비 완료',
      playing: '재생 중',
      pausing: '현재 단계를 마친 뒤 일시 정지합니다',
      paused: '일시 정지',
      skipped: '듣기 음성을 준비할 수 없는 카드를 건너뛰었습니다.',
      question: '질문',
      answer: '정답',
      article: '읽기',
      end: '연습 끝내기',
      endTitle: '연습을 끝낼까요?',
      endMessage: '완료한 듣기 반복을 저장하고 이번 연습을 끝냅니다.',
      home: '홈으로 돌아가기',
      retry: '다시 시도',
      preparationTimedOut: '음성 준비 시간이 너무 길어졌습니다. 다시 시도해 주세요.',
      noPlayable: '재생 가능한 듣기 음성이 있는 카드가 없습니다.',
      serviceUnavailable: '듣기 서비스를 잠시 사용할 수 없습니다. 서버가 다시 시작된 후 재시도해 주세요.',
      qUnavailable: '질문 음성을 재생할 수 없어 정답으로 계속합니다.',
      playbackInterrupted: '음성이 중단되었습니다. 재생 버튼을 눌러 이 카드를 다시 시도해 주세요.',
      ring: '카드 시작',
      blank: '말해 보세요',
      reading: '읽기',
      saving: '연습 기록을 저장하고 있습니다...',
      completeTitle: '훈련 세트 완료!',
      completeMessage: '연습 플레이어의 재생 목록을 모두 마쳤습니다.',
      timeTitle: '30분 완료!',
      timeMessage: '현재 카드를 마치고 30분 훈련을 완료했습니다.',
      currentCover: '현재 노트 표지',
      stepProgress: '플레이어 단계 진행률',
      seek: '읽기 음성 위치 이동',
      playControl: '연습 플레이어 재생',
      pauseControl: '연습 플레이어 일시 정지',
      previousCard: '이전 카드',
      nextCard: '다음 카드',
      trainerAlt: '응원하는 트레이너',
    },
  },
  presetLibrary: {
    unavailableTitle: 'Preset Library',
    unavailableMessage: 'Preset library for this language is not ready yet. Please ask AAStudio through Instagram.',
  },
  reviews: {
    title: '평점과 댓글',
    ratings: '개 평점',
    averageRating: '평균 평점',
    rateStar: '별점 {rating}점',
    leaveYours: '평점 남기기',
    editYours: '내 평점 수정하기',
    notice: '서로를 존중하는 댓글을 남겨 주세요. 부적절한 댓글은 삭제될 수 있습니다.',
    commentPlaceholder: '한 줄 댓글 (선택)',
    commentLabel: '평가 댓글',
    importFirst: '이 항목을 가져온 뒤 평가할 수 있습니다. 작성자는 공개되지 않습니다.',
    loading: '평가를 불러오는 중...',
    empty: '아직 평가가 없습니다.',
    loadFailed: '평가를 불러오지 못했습니다.',
    saveFailed: '평가를 저장하지 못했습니다.',
    saving: '저장 중...',
    save: '평가 저장',
    previous: '이전',
    next: '다음',
  },
  market: {
    eyebrow: '커뮤니티 라이브러리',
    title: '마켓',
    back: '도서관으로 돌아가기',
    topImported: '가장 많이 가져간 노트',
    topRated: '평점이 높은 노트',
    myUploads: '내가 올린 노트',
    board: '커뮤니티 게시판',
    search: '제목과 설명 검색',
    searchButton: '검색',
    sortLabel: '마켓 정렬',
    sort: { latest: '최신순', rating: '평점순', imports: '가져오기순' },
    loading: '마켓을 불러오는 중...',
    empty: '검색에 맞는 커뮤니티 노트가 없습니다.',
    publish: '마켓에 공개',
    publishing: '공개 중...',
    publishAction: '공개',
    backToMarket: '마켓으로 돌아가기',
    publishHelp: '현재 노트를 독립된 사본으로 공개합니다. 이후 내 노트를 수정해도 마켓의 내용은 바뀌지 않습니다.',
    communityEdition: '커뮤니티 에디션',
    by: '만든 사람',
    cards: '카드',
    level: '난이도',
    import: '노트 가져오기',
    imported: '가져옴',
    report: '신고',
    edit: '노트 수정',
    editAction: '수정',
    ownerActions: '마켓 노트 작업',
    moreActions: '마켓 노트 더 보기',
    publicationOn: '공개 ON',
    publicationOff: '공개 OFF',
    delete: '삭제하기',
    deleteConfirmTitle: '마켓 노트를 삭제할까요?',
    deleteConfirmMessage: '“{title}”을 마켓에서 영구 삭제합니다. 다른 학습자가 이미 가져간 노트에는 영향을 주지 않습니다.',
    withdraw: '공개 중단',
    restore: '다시 공개',
    examples: '노트 미리보기',
    examplesHelp: '카드를 5개씩 확인해 보세요.',
    previewPagination: '노트 미리보기 페이지',
    reportTitle: '이 노트 신고하기',
    reportDetails: '상세 내용 (선택, 한 줄)',
    submitReport: '신고 보내기',
    reportSent: '알려 주셔서 감사합니다. 관리자에게 신고가 전달되었습니다.',
    reportCategories: {
      inappropriate: '부적절한 내용',
      legal: '법률 또는 저작권 문제',
      misleading: '오해를 부르는 정보',
      harmful: '유해한 내용',
      other: '기타',
    },
    form: {
      cover: '표지 이미지',
      addImage: '이미지 추가',
      changeImage: '이미지 변경',
      removeImage: '이미지 삭제',
      selectImage: '표지 이미지 선택',
      coverPreview: '표지 미리보기',
      imageFormats: 'JPEG, PNG, WebP · 최대 5 MB',
      title: '제목',
      description: '설명',
      difficulty: '난이도',
      questionLanguage: '질문 언어',
      learningLanguage: '학습 언어',
      cardsText: '카드 내용',
      cardsTextHelp: '추출된 카드 텍스트를 수정하세요. 카드는 ---로 구분하고, 일반 카드는 @Q:/@A:, 읽기 카드는 @R: 형식을 사용합니다.',
    },
    status: { active: '공개 중', withdrawn: '공개 중단', removed: '삭제됨' },
    errors: {
      load: '마켓을 불러오지 못했습니다.',
      detail: '마켓 노트를 불러오지 못했습니다.',
      action: '요청을 완료하지 못했습니다.',
      notFound: '이 노트를 이용할 수 없습니다.',
      publish: '이 노트를 공개하지 못했습니다.',
      imageType: 'JPEG, PNG, WebP 이미지만 사용할 수 있습니다.',
      imageSize: '이미지는 5 MB 이하여야 합니다.',
    },
  },
  noteComposer: {
    locales: {
      'en-US': '영어 (미국)',
      'ko-KR': '한국어',
      'ja-JP': '일본어',
      'zh-CN': '중국어 (중국 본토)',
      'es-ES': '스페인어 (스페인)',
    },
    types: {
      simple: '간단 카드',
      normal: '카드',
      article: '아티클',
      dialog: '대화',
    },
    page: {
      eyebrow: '노트 편집',
      addNoteTitle: '새 노트 추가',
      createHelp: '노트 이름을 정하고 학습할 카드를 추가하세요.',
      addCardsTitle: '플래시카드 추가',
      contentHeading: '노트 내용',
      noteName: '이름',
      noteNamePlaceholder: '노트 이름을 입력하세요',
      practiceState: '훈련에 포함',
      enabled: '활성',
      disabled: '비활성',
      enabledDescription: '이 노트를 훈련에 포함합니다.',
      disabledDescription: '아직 훈련에 넣지 않고 내용을 정리할 수 있습니다.',
      addOneCard: '카드 하나 추가',
      copyFormats: '포맷 복사',
      copied: '복사됨',
      manual: '매뉴얼',
      copyGuidance: '포맷을 메모 앱에 붙여 넣고 나만의 노트를 만들어 보세요.',
      contentLabel: '내용',
      contentPlaceholder: '플래시카드를 붙여 넣거나 ‘카드 하나 추가’를 사용하세요.',
      review: '카드 확인',
      back: '돌아가기',
      loading: '노트 불러오는 중...',
    },
    builder: {
      kicker: '카드 만들기',
      title: '카드 하나 추가',
      typeLegend: '카드 종류',
      formatLabel: '포맷 텍스트',
      previewLabel: '미리보기 및 문법 확인',
      checking: '포맷을 확인하는 중...',
      addCard: '노트에 추가',
    },
    preview: {
      showQuestion: '질문 보기',
      showAnswer: '답변 보기',
    },
    confirm: {
      kicker: '최종 확인',
      title: '새 카드 확인',
      count: '{count}개의 카드가 저장됩니다.',
      save: '카드 저장',
      saving: '저장 중...',
      questionLocale: '질문 언어',
      learningLocale: '학습 언어',
      detected: '카드 내용에서 추천했습니다. 저장 전에 변경할 수 있습니다.',
      defaulted: '정확히 판별하지 못했습니다. 저장 전에 확인해 주세요.',
    },
    errors: {
      empty: '플래시카드를 하나 이상 입력하세요.',
      parseFailed: '카드를 읽을 수 없습니다. {details}',
      oneCardOnly: '이 창에서는 한 번에 카드 하나만 추가할 수 있습니다. 현재 {count}개가 있습니다.',
      simpleTooLong: '답변이 간단 카드로 사용하기에는 너무 깁니다. 줄이거나 ‘카드’를 선택하세요.',
      typeMismatch: '입력한 형식은 {expected}이(가) 아니라 {actual}입니다. 종류나 태그를 확인하세요.',
      noteNameRequired: '노트 이름을 입력하세요.',
      cardLimit: '한 노트에는 최대 {max}개의 카드를 넣을 수 있습니다. 현재 {current}개이고 {added}개를 추가하려고 합니다.',
      loadNote: '노트를 불러오지 못했습니다. {details}',
      copyFailed: '포맷을 복사하지 못했습니다. 클립보드 권한을 확인하세요.',
      reviewFailed: '기존 카드를 확인하지 못했습니다. {details}',
      saveFailed: '카드를 저장하지 못했습니다. {details}',
      syntax: {
        empty: '플래시카드를 하나 이상 입력하세요.',
        incompleteCard: '기본 카드는 질문과 답변, 정확히 두 줄이 필요합니다.',
        qaRequired: '태그 카드에는 @Q:와 @A:가 모두 필요합니다.',
        readingTitle: '@R: 뒤에 읽기 카드의 제목을 입력하세요.',
        readingPractice: '읽기 카드에는 @Story:, @A:, 또는 @B: 아래에 연습할 내용이 필요합니다.',
        continuation: '@R: 뒤의 텍스트는 @Story:, @Scene:, @A:, 또는 @B: 다음에 입력하세요.',
        tagNeedsText: '빈 태그가 있습니다. 태그 뒤나 다음 줄에 내용을 입력하세요.',
        legacyTag: '예전 태그가 사용되었습니다. @Q:, @A:, @R: 형식을 사용하세요.',
        unsupportedTag: '지원하지 않는 태그가 있습니다. 복사한 포맷과 비교해 보세요.',
        taggedLine: '태그 카드는 지원하는 @ 태그를 사용해야 합니다.',
        mixedCard: '하나의 카드에 @R: 형식과 @Q:/@A: 형식을 함께 사용할 수 없습니다.',
        generic: '포맷에 문법 오류가 있습니다. 구분선과 필수 태그를 확인하세요.',
      },
    },
  },
  notes: {
    importComplete: '"{title}" 노트를 가져왔어요. 활성 상태로 바로 연습할 수 있어요.',
    enabled: '활성',
    disabled: '비활성',
    enable: '활성화',
    disable: '비활성화',
    savingState: '저장 중...',
    stateUpdateFailedTitle: '상태를 저장하지 못했어요',
    stateUpdateFailedMessage: '노트 상태를 변경하지 못했습니다. 다시 시도해 주세요.',
    disabledPracticeTitle: '비활성 노트입니다',
    disabledPracticeMessage: '훈련을 시작하려면 맵 페이지에서 이 노트를 활성화해 주세요.',
  },
  library: {
    title: '도서관', subtitle: '다음 배움을 함께할 노트를 찾아보세요.', back: '훈련소 홈으로',
    discover: '둘러보기', all: '전체보기', officialTab: '공식', market: '마켓', navigation: '도서관 메뉴',
    myUploads: '내 업로드', publish: '노트 공개', filters: '도서관 필터',
    searchFilters: '검색 및 필터', openSearchFilters: '검색 및 필터 열기', closeSearchFilters: '검색 및 필터 닫기', activeFilters: '{count}개 적용 중',
    audience: '질문 언어', learningLanguage: '학습 언어', allLanguages: '모든 언어',
    search: '제목, 주제, 제작자로 검색', searchButton: '검색',
    difficulty: '난이도', allLevels: '모든 난이도', topic: '주제', allTopics: '모든 주제',
    source: '제작 구분', allSources: '전체', official: '공식 컬렉션', community: '커뮤니티',
    officialLibrary: '공식 라이브러리', unclassified: '주제 미분류',
    groupBy: '그룹 기준', unknownLanguage: '언어 미분류', unknownDifficulty: '난이도 미분류',
    pageGroupCount: '이 페이지의 그룹 내 노트 {count}개',
    sort: '정렬', defaultSort: '추천순', latest: '최신순', ratingSort: '평점순', importSort: '가져오기순',
    officialShelf: '이 노트부터 시작해 보세요', officialIntro: '공식 컬렉션에서 골라 소개하는 학습 노트예요.',
    marketShelf: '함께 만드는 배움', marketIntro: '다른 학습자가 나눈 노트에서 새로운 배움을 만나보세요.',
    favorites: '즐겨찾기', favoritesIntro: '저장해 둔 노트를 다시 만나보세요.',
    viewAll: '모두 보기', exploreAll: '전체 도서관 살펴보기',
    openGroup: '{title} 그룹 열기', openFavoritesGroup: '즐겨찾기 그룹 열기', viewGroup: '목록 확인', groupItemCount: '노트 {count}개',
    selectedGroup: '그룹: {group}', clearGroup: '그룹 필터 해제',
    openItem: '{title} 열기', imported: '가져옴', recommended: '추천', clickedNote: '클릭한 노트', cardCount: '카드 {count}개', level: '난이도 {level}',
    results: '도서관 검색 결과', resultCount: '노트 {count}개',
    managementHint: '질문 언어에 관계없이 내가 공개하거나 비공개로 전환한 노트를 표시합니다.',
    limitedResults: '검색 결과가 500페이지를 초과했어요. 필터를 좁히면 나머지 노트도 찾을 수 있습니다.',
    empty: '조건에 맞는 노트가 아직 없어요. 다른 언어를 선택하거나 필터를 초기화해 보세요.',
    clearFilters: '필터 초기화', loading: '도서관을 불러오는 중…', loadError: '도서관을 불러오지 못했어요.', retry: '다시 시도',
    pagination: '도서관 페이지', previous: '이전', next: '다음', pageStatus: '{page} / {pageCount}',
    presetPreviewTitle: '노트 미리보기', presetPreviewHelp: '카드를 5개씩 확인해 보세요.', presetPreviewEmpty: '미리 볼 카드가 없어요.', previewPagination: '공식 노트 미리보기 페이지', readingCard: '읽기',
    languages: { ko: '한국어', en: '영어', ja: '일본어', zh: '중국어', es: '스페인어' },
    difficulties: { 1: '입문', 2: '초급', 3: '중급', 4: '중상급', 5: '고급' },
  },
  notification: {
    eyebrow: '알림',
    defaultTitle: '새 알림',
    dontShowAgain: '다시 보지 않기',
    closeLabel: '알림 닫기',
  },
};

export default ko;
